export default {"src":"/_next/static/media/html5_logo_1176002236.b51b0208.svg","height":160,"width":320,"blurWidth":0,"blurHeight":0};